import type { MemberFormKey } from '@/view-models/member'
import { useAlertStore } from '@/store-pinia/alert'

export function useMemberProfileField() {
  const { $store, $i18n } = useNuxtApp()
  const alertStore = useAlertStore()

  const isSaving = ref(false)

  async function saveField(key: MemberFormKey, value: string | number | null, label: string): Promise<boolean> {
    const payload = typeof value === 'string' ? value.trim() : value

    isSaving.value = true
    try {
      const res = await $store.dispatch('authentication/updateUserInfo', { [key]: payload })

      if (res?.code !== 0) {
        alertStore.showAlert({ message: res?.message || $i18n.t('general_system_error'), type: 'error' })
        return false
      }

      await $store.dispatch('authentication/getUserInfo')

      alertStore.showAlert({ message: $i18n.t('edit_save_successful_hint', { value: label }), type: 'success' })
      return true
    } catch {
      alertStore.showAlert({ message: $i18n.t('general_system_error'), type: 'error' })
      return false
    } finally {
      isSaving.value = false
    }
  }

  return { saveField, isSaving }
}
